import withStyles from "isomorphic-style-loader/lib/withStyles";
import {
  parse as parseQueryParams,
  stringify as objectToQueryParams
} from "query-string";
import React from "react";
import { withRouter } from "react-router-dom";
import {
  Col,
  Container,
  Form,
  FormGroup,
  FormText,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent
} from "reactstrap";
import {
  PARTNER_MEMB_ACTIVE_STATUS,
  PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS,
  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
  PARTNER_MEMB_PENDIENTE_PAGO_STATUS,
  PARTNER_MEMB_PENDIENTE_REACTIVACION_STATUS,
  PARTNER_MEMB_PENDIENTE_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS
} from "../../../../src/utils/constants";
import { handleOBRequestError } from "../../../utils/helpers";
import { getExpedienteFromMembresia_ } from "../../actions/expedientes";
import {
  getPaymentMethodsRequest,
  searchMovementsByClubAndMembershipRequest
} from "../../actions/partners";
import { loginUserSSP_ } from "../../actions/session";
import { Props, State } from "./interfaces";
import s from "./styles.scss";
import TabActivated from "./tabActivated";
import TabDocuments from "./tabDocuments";
import TabMovements from "./tabMovements";
import TabTokenization from "./tabTokenization/tabTokenization";
import OBLoader from "../../../OnBoardingUI/components/OBLoader/OBLoader.component";
import { errorOBNotification } from "../../../OnBoardingUI/components/OBNotification/OBNotification.utils";
import ok from "../../../OnBoardingUI/media/images/ok.png";
import { setOBSubTitle } from "../../../OnBoardingUI/components/OBLayout/OBLayout.utils";

const ESTATUS_MEMBRESIA_BLOQUEO_NUEVO_FLUJO = [
  PARTNER_MEMB_PENDIENTE_STATUS,
  PARTNER_MEMB_PENDIENTE_CON_ANUALIDAD_STATUS,
  PARTNER_MEMB_PENDIENTE_REACTIVACION_STATUS,
  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS,
  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS,
  PARTNER_MEMB_PENDIENTE_PAGO_STATUS
];

const loginData = {
  userName: "i.selfonb",
  password: "Ara2024.",
  ssp: { id: -1, userName: "" }
};

class PartnersSaleFlow extends React.Component<Props, State> {
  state = {
    filters: {
      idClub: "",
      idPublico: ""
    },
    idMembresiaSocio: "",
    activeTab: "1",
    partner: null,
    users: [],
    documentInstances: [],
    movementsList: [],
    paymentMethods: [],
    searching: false,
    loadingData: false,
    loadingDataMessage: null,
    expediente: null,
    plataforma: "SELF_ONBOARDING"
  };

  componentDidMount() {
    this.setState({ searching: true });

    loginUserSSP_(loginData)
      .then(({ data }) => {
        console.info(data);
        const { idPublico, idClub, plataforma } = parseQueryParams(
          this.props.location.search
        );
        if (idPublico && idClub) {
          this.searchParner({
            idPublico,
            idClub
          });
        }

        if (plataforma) {
          this.setState({ plataforma });
        }
      })
      .catch(handleOBRequestError);
  }

  componentDidUpdate(prevProps): void {
    if (!prevProps.partnerCreated && this.props.partnerCreated) {
      this.refreshPartner();
    }
  }

  searchParner = filters => {
    this.setState({
      filters: { ...filters }
    });

    this.props
      .getPartner(filters)
      .then(async ({ value: { data } }) => {
        this.props.history.push(
          `/self-onboarding/${data.idMembresiaSocio}?${objectToQueryParams(
            filters
          )}`
        );

        this.setState({ partner: data, searching: false }, () => {
          this.getPaymentMethods();

          if (
            ESTATUS_MEMBRESIA_BLOQUEO_NUEVO_FLUJO.includes(
              data.estatusMembresia
            )
          ) {
            setOBSubTitle("Membresía Socio");
          }
        });

        switch (data.estatusMembresia) {
          case PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS:
            this.toggleTab("1");
            break;
          case PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS:
            this.toggleTab("2");
            this.getPartnerMembershipExpediente();
            break;
          case PARTNER_MEMB_PENDIENTE_PAGO_STATUS:
            this.toggleTab("3");
            this.getMovements();
            break;
          case PARTNER_MEMB_ACTIVE_STATUS:
            this.toggleTab("4");
            break;
        }
      })
      .catch(error => {
        this.setState({ searching: false });
        errorOBNotification(
          "¡Oops! No te encontramos, intenta de nuevo más tarde por favor."
        );
      });
  };

  refreshPartner = () => {
    const { idPublico, idClub } = parseQueryParams(this.props.location.search);

    if (idPublico && idClub) {
      this.searchParner({
        idPublico,
        idClub
      });
    }
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  //-----------------------------------------------------------------------------

  getPaymentMethods = () => {
    const { idMembresiaSocio } = this.props.partner;

    this.setState({
      loadingData: true,
      loadingDataMessage: "Cargando medios de pago"
    });

    getPaymentMethodsRequest(idMembresiaSocio)
      .then(({ data }) => {
        this.setState({ paymentMethods: [...data], loadingData: false });
      })
      .catch(error => {
        this.setState({ loadingData: false });
        handleOBRequestError(error);
      });
  };

  getMovements = () => {
    const { movementsList } = this.state;

    if (movementsList == null || movementsList.length == 0) {
      const {
        idPublico: membresiaSocioIdPublico,
        idClub: clubId
      } = parseQueryParams(this.props.location.search);

      this.setState({
        loadingData: true,
        loadingDataMessage: "Cargando movimientos"
      });

      searchMovementsByClubAndMembershipRequest({
        clubId,
        membresiaSocioIdPublico
      })
        .then(({ data }) => {
          this.setState({ movementsList: data, loadingData: false });
        })
        .catch(error => {
          this.setState({ loadingData: false });
          handleOBRequestError(error);
        });
    }
  };

  getPartnerMembershipExpediente = async () => {
    const { expediente } = this.state;
    const { idMembresiaSocio } = this.props.partner;

    if (expediente == null) {
      this.setState({
        loadingData: true,
        loadingDataMessage: "Cargando expediente"
      });

      try {
        const { data: expediente } = await getExpedienteFromMembresia_(
          idMembresiaSocio
        );
        console.info(expediente);
        this.setState({ expediente, loadingData: false });
      } catch (error) {
        this.setState({ loadingData: false });
        handleOBRequestError(error);
      }
    }
  };

  invalidateStateValue = (fieldName, value) => {
    this.setState({ ...this.state, [fieldName]: value });
  };

  isMembershipOnStatus = status => {
    return (
      !!this.props.partner &&
      (status || "") == this.props.partner.estatusMembresia
    );
  };

  isMembershipBlockedNuevoFlujoVenta = () => {
    const bloqueado =
      !!this.props.partner &&
      ESTATUS_MEMBRESIA_BLOQUEO_NUEVO_FLUJO.includes(
        this.props.partner.estatusMembresia
      );

    if (!bloqueado) {
      setOBSubTitle("");
    }

    return bloqueado;
  };

  renderNavItem = ({
    activeTabNumber,
    onClick,
    titleTop,
    titleDown,
    disabled = false,
    render = true
  }) => {
    const _render = render;

    return _render ? (
      <NavItem>
        <NavLink
          className={`${
            this.state.activeTab === activeTabNumber ? `active ${s.active}` : ""
          } ${s.tab}`}
          onClick={() => {
            this.toggleTab(activeTabNumber);

            if (!!onClick) {
              onClick();
            }
          }}
          disabled={false}
        >
          {titleTop}
          <br />
          {titleDown}
          <div className={s.tabFloor}></div>
        </NavLink>
      </NavItem>
    ) : null;
  };

  render() {
    return (
      <Container className="p-0 container" fluid>
        {!!this.state.searching && (
          <OBLoader
            activity={"Espera un momento por favor"}
            loading={this.state.searching}
          />
        )}

        {/*this.props.partner && (
          <Row>
            <Col xs={12}>
              <div className="m-2" style={{
                  fontSize: "14px",
                  textAlign: "center",
                }}
              >
                {(this.props.partner || {}).nombrePersona || ""}
              </div>
            </Col>
          </Row>
        )*/}

        {/* REQ: Fernanda Urióstegui - Nuevo mensaje de activación */}
        {this.props.partner && !this.isMembershipBlockedNuevoFlujoVenta() && (
          <Container className="w-100 p-0 m-0" xs={12}>
            <div
              style={{
                fontSize: "24px",
                textAlign: "center",
                fontWeight: "bold",
                marginTop: "48px"
              }}
            >
              Bienvenido a Sports{" "}
              <span style={{ color: "#E02519" }}>World</span>
            </div>

            <div
              style={{
                fontSize: "20px",
                textAlign: "center"
              }}
            >
              Tu membresía ya está activa
            </div>

            <div style={{ textAlign: "center", margin: "64px 0" }}>
              <img
                src={ok}
                alt="^^"
                style={{
                  width: "152px",
                  height: "152px"
                }}
              />
            </div>

            <div style={{ marginLeft: "32px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "4px"
                }}
              >
                Nombre del cliente:
              </div>
              <div
                style={{
                  fontSize: "12px",
                  marginBottom: "10px"
                }}
              >
                {this.props.partner.nombrePersona}
              </div>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "14px",
                  marginBottom: "4px"
                }}
              >
                Gracias por tu compra
              </div>
              <div
                style={{
                  fontSize: "12px",
                  marginBottom: "10px"
                }}
              >
                Has completado la activación de tu membresía
              </div>
            </div>
          </Container>
        )}

        {this.props.partner && !!this.isMembershipBlockedNuevoFlujoVenta() && (
          <Container
            className="w-100 p-0 m-0"
            style={{ height: "650px" }}
            xs={12}
          >
            <Nav className={s.tabs} tabs>
              {this.renderNavItem({
                activeTabNumber: "1",
                onClick: () => {
                  this.getPaymentMethods();
                },
                titleTop: "Validación",
                titleDown: "de tarjeta",
                disabled: !this.isMembershipOnStatus(
                  PARTNER_MEMB_PENDIENTE_TOKENIZACION_STATUS
                ),
                render: !!this.isMembershipBlockedNuevoFlujoVenta()
              })}

              {this.renderNavItem({
                activeTabNumber: "2",
                onClick: () => {
                  this.getPartnerMembershipExpediente();
                },
                titleTop: "Firma de",
                titleDown: "documentos",
                disabled: !this.isMembershipOnStatus(
                  PARTNER_MEMB_PENDIENTE_FIRMA_CAT_STATUS
                ),
                render: !!this.isMembershipBlockedNuevoFlujoVenta()
              })}

              {this.renderNavItem({
                activeTabNumber: "3",
                onClick: () => {
                  this.getMovements();
                },
                titleTop: "Pago",
                titleDown: "final",
                disabled: !this.isMembershipOnStatus(
                  PARTNER_MEMB_PENDIENTE_PAGO_STATUS
                ),
                render: !!this.isMembershipBlockedNuevoFlujoVenta()
              })}

              {/*this.renderNavItem({
                activeTabNumber: "4",
                onClick: null,
                titleTop: "Activación",
                titleDown: "completa",
                disabled: !this.isMembershipOnStatus(
                  PARTNER_MEMB_PENDIENTE_PAGO_STATUS
                ),
                render: !this.isMembershipBlockedNuevoFlujoVenta()
              })*/}
            </Nav>

            {this.props.partner && !!this.isMembershipBlockedNuevoFlujoVenta() && (
              <TabContent className="h-100" activeTab={this.state.activeTab}>
                <TabTokenization
                  partner={this.props.partner}
                  idMembresiaSocio={this.props.partner.idMembresiaSocio}
                  paymentMethods={this.state.paymentMethods}
                  getPaymentMethods={this.getPaymentMethods}
                  refreshPartner={this.refreshPartner}
                  invalidateStateValue={this.invalidateStateValue}
                  loadingData={this.state.loadingData}
                  loadingDataMessage={this.state.loadingDataMessage}
                  plataforma={this.state.plataforma}
                />

                <TabDocuments
                  partner={this.props.partner}
                  idMembresiaSocio={this.props.partner.idMembresiaSocio}
                  invalidateStateValue={this.invalidateStateValue}
                  refreshPartner={this.refreshPartner}
                  getPartnerMembershipExpediente={
                    this.getPartnerMembershipExpediente
                  }
                  expediente={this.state.expediente || null}
                  loadingData={this.state.loadingData}
                  loadingDataMessage={this.state.loadingDataMessage}
                />

                <TabMovements
                  partner={this.props.partner}
                  movementsList={this.state.movementsList}
                  idMembresia={this.props.partner.idMembresia}
                  idMembresiaSocio={this.props.partner.idMembresiaSocio}
                  getMovements={this.getMovements}
                  invalidateStateValue={this.invalidateStateValue}
                  refreshPartner={this.refreshPartner}
                  loadingData={this.state.loadingData}
                  loadingDataMessage={this.state.loadingDataMessage}
                  plataforma={this.state.plataforma}
                />

                <TabActivated partner={this.props.partner} />
              </TabContent>
            )}
          </Container>
        )}
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(PartnersSaleFlow));
